import {get, post} from "@/utils/utils";

const auditConfiguration = {
  state: {},
  mutations: {
    QUERY_EXAMINE_CONFIG_LIST() {},
    INIT_EXAMINE_COFIG() {},
    QUERY_EXAMINE_CONFIG_STEP_LIST() {},
    SAVE_EXAMINE_CONFIG() {},
    UPDATE_ENABLED_STATE() {},
    OPERATE_EXAMINE_CONFIG_STEP() {},
    OPERATE_EXAMINE_CONFIG_STEP_INFO() {},
    UPDATE_EXAMINE_CONFIG_STEP_INFO() {},
    QUERY_STORE_EXAMINE_LIST() {},
    OPERATE_EXAMINE() {},
    QUERY_EXAMINE_STATUS_LIST() {},
    QUERY_EXAMINE_CONFIG() {},
    QUERY_EXAMINE_FROM() {},
    QUERY_AWAIT_EXAMINE_LIST() {},
    INIT_STORE_DATA() {},
    EXPORT_STORE_EXAMINE_LIST() {}
  },
  actions: {
    queryExamineConfigList({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryExamineConfigList`,
        name: "QUERY_EXAMINE_CONFIG_LIST",
        params
      });
    },
    initializeStoreExamineConfig({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/initializeStoreExamineConfig`,
        name: "INIT_EXAMINE_COFIG",
        params
      });
    },
    queryExamineConfigStepInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryExamineConfigStepInfoList`,
        name: "QUERY_EXAMINE_CONFIG_STEP_LIST",
        params
      });
    },
    saveExamineConfigStepInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/saveExamineConfigStepInfo`,
        name: "SAVE_EXAMINE_CONFIG",
        params
      });
    },
    updateEnabledState({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/updateEnabledState`,
        name: "UPDATE_ENABLED_STATE",
        params
      });
    },
    operateExamineConfigStepInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/operateExamineConfigStepInfo`,
        name: "OPERATE_EXAMINE_CONFIG_STEP",
        params
      });
    },
    queryExamineConfigStepInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryExamineConfigStepInfo`,
        name: "OPERATE_EXAMINE_CONFIG_STEP_INFO",
        params
      });
    },
    updateExamineConfigStepInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/updateExamineConfigStepInfo`,
        name: "UPDATE_EXAMINE_CONFIG_STEP_INFO",
        params
      });
    },
    queryStoreExamineList({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryStoreExamineList`,
        name: "QUERY_STORE_EXAMINE_LIST",
        params
      });
    },
    storeExamineListExport({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/storeExamineListExport`,
        name: "EXPORT_STORE_EXAMINE_LIST",
        params
      });
    },
    operateExamine({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/operateExamine`,
        name: "OPERATE_EXAMINE",
        params
      });
    },
    queryExamineStatusRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryExamineStatusRecordList`,
        name: "QUERY_EXAMINE_STATUS_LIST",
        params
      });
    },
    queryExamineConfig({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryExamineConfigList`,
        name: "QUERY_EXAMINE_CONFIG",
        params
      });
    },
    queryShareRuleDynamicFormInputRecord({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareMemberRelInfo/queryShareRuleDynamicFormInputRecord`,
        name: "QUERY_EXAMINE_FROM",
        params
      });
    },
    queryWaitExamineList({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryWaitExamineList`,
        name: "QUERY_AWAIT_EXAMINE_LIST",
        params
      });
    },
    initStoreData({ commit }, params) {
      return get({
        commit,
        url: `/storeBasicInfo/init_store_data`,
        name: "INIT_STORE_DATA",
        params
      });
    }
  }
};

export default auditConfiguration;
